import * as React from 'react';

const useIsServerSideRendered = () => {
    const [isServerSideRendered, setIsServerSideRendered] = React.useState(true);

    React.useEffect(() => {
        setIsServerSideRendered(false);
    }, []);

    return isServerSideRendered;
};

export default useIsServerSideRendered;
